import { Button } from "reactstrap";

//Componentes
import TooltipItem from "./TooltipItem";

//Util
import { ICONES_BOTAO, ICONES_CARD_DASHBOARD } from "../utils/icones";

/*
 * Card do dashboard (layout novo). Recebe as mesmas propriedades do CardDashboard, que continua existindo:
 * para voltar ao layout antigo basta trocar o import na tela do dashboard.
 * O estilo fica no app.css (classes "card-dash").
 * @onDetalhar: Opcional. Quando informada, o card apresenta o botão de detalhamento, que chama essa função.
 *              Sem ela o card não apresenta o botão.
 * @detalharDesabilitado: Desabilita o botão de detalhamento (Ex: quando o card não possui registro)
 * @backgroundColor: Opcional. Card de destaque: a cor é aplicada bem suave no fundo e na faixa lateral.
 */
function CardDashboardNovo({
  titulo,
  subtitulo,
  valor1,
  valor2,
  valor3,
  msgHelpValor1,
  msgHelpValor2,
  rodape,
  nomeIcone,
  backgroundColor,
  fixarAlturaConteudo = true,
  onDetalhar,
  detalharDesabilitado = false,
}) {
  //Classe da cor do card conforme o ícone (faixa lateral e ícone)
  function getClassCor() {
    switch (nomeIcone) {
      case "SUCESSO":
      case "CHECK":
        return "card-dash-sucesso";
      case "AVISO":
        return "card-dash-aviso";
      case "ATENCAO":
      case "ERRO":
        return "card-dash-erro";
      default:
        return "";
    }
  }

  //Apresenta a linha ou mantém o espaço dela, para os cards da mesma linha ficarem alinhados
  function renderLinha(condicao, conteudo, className, msgHelp) {
    if (condicao)
      return (
        <div className={className}>
          {conteudo}

          {msgHelp && (
            <span className="ms-1">
              <TooltipItem text={msgHelp} showImageHelp />
            </span>
          )}
        </div>
      );

    if (fixarAlturaConteudo) {
      return (
        <div className={className} style={{ visibility: "hidden" }}>
          placeholder
        </div>
      );
    }

    return null;
  }

  return (
    <div
      className={`card-dash ${getClassCor()} ${backgroundColor ? "card-dash-destaque" : ""}`}
      style={backgroundColor ? { "--card-dash-destaque": backgroundColor } : {}}
    >
      {/* Título */}
      <div className="card-dash-topo">
        <div>
          <div className="card-dash-titulo">{titulo}</div>

          {renderLinha(!!subtitulo, subtitulo, "card-dash-subtitulo")}
        </div>
      </div>

      {/* Valores e ícone */}
      <div className="card-dash-corpo">
        <div>
          {/* Valor 1 (valor principal) */}
          {renderLinha(
            valor1 !== null && valor1 !== undefined,
            valor1,
            "card-dash-valor1",
            msgHelpValor1,
          )}

          {/* Valor2 */}
          {renderLinha(
            valor2 !== null && valor2 !== undefined,
            valor2,
            "card-dash-valor2",
            msgHelpValor2,
          )}

          {/* Valor3 (qtde de pagamentos/solicitações) e, ao lado, o botão de detalhamento (opcional) */}
          {onDetalhar ? (
            <div className="card-dash-valor3 d-flex align-items-center gap-1">
              {valor3}

              <Button
                name="btnDetalharCard"
                color="light"
                className="card-dash-btn-detalhar"
                title="Detalhar"
                aria-label={`Detalhar ${titulo || ""} ${subtitulo || ""}`.trim()}
                onClick={onDetalhar}
                disabled={detalharDesabilitado}
              >
                {ICONES_BOTAO.DETALHAR}
              </Button>
            </div>
          ) : (
            renderLinha(!!valor3, valor3, "card-dash-valor3")
          )}
        </div>

        {nomeIcone && (
          <div className="card-dash-icone">
            {ICONES_CARD_DASHBOARD[nomeIcone]}
          </div>
        )}
      </div>

      {/* Rodapé */}
      {renderLinha(!!rodape, rodape, "card-dash-rodape")}
    </div>
  );
}

export default CardDashboardNovo;
